import { FormTemplate } from "components/modal/templates";
import ContactInfo from "components/shared/contactInfo";
import { getCustomNumberConfig, serializeReq } from "components/shared/form";
import { featureModuleTypesEnum } from "helpers/enums";
import { checkMechanic } from "helpers/mechanics";
import { truckNumber } from "helpers/validators";
import { prepareVehicleOwnershipData } from "helpers/vehicles/ownership";
import { FuelTanks } from "helpers/vehicles/partials";
import policy from "policies";
import React from "react";
import { getByPhoneNumber } from "sources/books/mechanics";
import { attach } from "sources/books/trackers";
import { apply } from "sources/books/trucks";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreateTruckModal extends FormTemplate {
    getValidationConfig = (state) => {
        return {
            ...this.props.config,
            number: getCustomNumberConfig({
                number: this.props.config.number,
                useCustomNumber: !!state.useCustomNumber,
                numberValidator: truckNumber,
            }),
        };
    };

    componentDidMount() {
        const initial = this.props.initialState ? this.props.initialState : {};
        if (
            this.props.profile.availableFeatureModules.includes(featureModuleTypesEnum.RefuelingPlanning) &&
            !this.props.refuelingSettings.hideRefuelingPlanning
        ) {
            this.setState({
                isLoading: false,
                isValid: true,
                ...initial,
                isInRefuelingSyncList: this.props.refuelingSettings.addCarToRefuelingSyncByDefault,
            });
        } else {
            this.setState({ isLoading: false, isValid: true, ...initial });
        }
    }

    sendRequest = (stateData) => {
        const { useCustomNumber, ...data } = stateData;
        return apply(data);
    };

    handleSubmit = (e) => {
        e.preventDefault();
        const { isLoading, ...state } = this.state;
        const serialized = serializeReq(prepareVehicleOwnershipData(state));
        const { trackerId } = serialized;
        if (!isLoading) {
            if (this.isValidForm(state)) {
                this.setState({ isLoading: true, isValid: true });
                checkMechanic(state);
                return this.sendRequest(serialized).then((res) => {
                    if (res) {
                        this.props.mergeParams?.();
                        this.props.onSuccess?.(res);
                        if (trackerId) {
                            this.attachTracker({ CarId: res.id, Id: trackerId });
                        } else {
                            this.close();
                        }
                    } else {
                        this.setState({ isLoading: false, isValid: false });
                    }
                });
            }
            this.setState({ isValid: false });
        }
    };

    setValue = ({ name, value, option }) => {
        const isValid = this.isValidForm({ ...this.state, [name]: value });
        const { selectedOptions } = this.state;
        this.setState({
            [name]: value,
            selectedOptions: { ...selectedOptions, [name]: option },
            ...(isValid ? { isValid: true } : {}),
        });
    };

    setCustomNumberMode = ({ value }) => {
        const number = value ? this.state.number : "";
        const nextState = { ...this.state, number, useCustomNumber: value };
        const isValid = this.isValidForm(nextState);
        this.setState({ number, useCustomNumber: value, ...(isValid ? { isValid: true } : {}) });
    };

    attachTracker = (params) => {
        attach(params).then((res) => (res ? this.close() : this.setState({ isLoading: false, isValid: false })));
    };

    renderFuelTanks = () => {
        const { modal, config, canEditBooks } = this.props;
        const props = {
            canEditBooks,
            modal,
            config: config.fuelTanks,
            fuelTanks: this.state.fuelTanks,
            setValue: this.setValue,
            createAction: true,
        };

        return <FuelTanks {...props} />;
    };

    renderMechanic = () => {
        const props = {
            renderField: this.renderField,
            contact: this.state.mechanic,
            setValue: this.setValue,
            config: this.props.config.mechanic,
            getContactInfo: getByPhoneNumber,
            fieldName: "mechanic",
        };
        return <ContactInfo {...props} />;
    };

    renderСolumnDispatcher = () => {
        const props = {
            renderField: this.renderField,
            contact: this.state.columnDispatcher,
            setValue: this.setValue,
            config: this.props.config.columnDispatcher,
            getContactInfo: getByPhoneNumber,
            fieldName: "columnDispatcher",
        };
        return <ContactInfo {...props} />;
    };

    renderBodyInner = () => {
        const { config, profile, refuelingSettings } = this.props;
        const props = {
            renderField: this.renderField,
            renderSelect: this.renderSelect,
            renderCheckbox: this.renderCheckbox,
            renderFuelTanks: this.renderFuelTanks,
            setCustomNumberMode: this.setCustomNumberMode,
            data: this.state,
            renderMechanic: this.renderMechanic,
            renderСolumnDispatcher: this.renderСolumnDispatcher,
            gasDieselValue: this.state.gasDiesel,
            availableFeatureModules: profile.availableFeatureModules,
            organizationName: profile.organizationName,
            setValue: this.setValue,
            refuelingSettings,
        };
        return <Markup {...config} {...props} />;
    };
}

const ConfiguredModal = (props) => {
    if (!policy("user", { user: { roles: props.roles } }).isTruckingOrganizationAdmin()) {
        config.transportColumnId.disabled = true;
    }
    return <CreateTruckModal {...props} config={config} initialState={{ ...initialState, useCustomNumber: false }} />;
};

export default ConfiguredModal;
